import { FC } from 'react';
import { useTheme } from '@material-ui/core';
import { WbCard, WbCardProps } from '../WbCard';

/**
 * @deprecated WbWidget is a thin convenience wrapper around WbCard and
 * will be removed in a future release. Prefer using WbCard directly with the
 * desired styles (border, shadow, header overflow) to avoid double wrapping.
 */
export const WbWidget: FC<WbCardProps> = ({
  children,
  cardStyle,
  headerStyle,
  footerStyle,
  ...props
}) => {
  const theme = useTheme();

  return (
    <WbCard
      headerStyle={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        ...headerStyle,
      }}
      cardStyle={{
        boxShadow: 'none',
        border: `1px solid ${theme.palette.divider}`,
        ...cardStyle,
      }}
      footerStyle={{
        ...footerStyle,
      }}
      {...props}
    >
      {children}
    </WbCard>
  );
};
